import { Route } from '../Routing/types';
import { TrackerSettingsPage } from '@front-activerse/modules';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/tracker-settings',
    element: <TrackerSettingsPage />,
    private: true,
    title: dummy_t('trackerSettings.navbarTitle'),
    mobileAppTabIdentifier: '',
  },
];

export default routes;
